// extracted by mini-css-extract-plugin
export default {"root":"Ng2hMrPY0eRPizJdIc7s","rootBackdrop":"e9JMOdVnx5KeHXxN4wka","background":"fyvLFzzpbbU3vZ0BLart"};